// const URL_BACKEND = "http://192.168.32.231:8085";

const URL_BACKEND = "https://4learn.softensistemas.com.br/api";

export default URL_BACKEND;
